<template>
  <div class="inquiry">
    <div class="inquiry-header">
      <h2 v-if="!reports.length" class="desktop">Създаване на справка</h2>
      <h2 v-else class="desktop">Преглед на справка</h2>
      <div class="inquiry-header-controlls" ref="top">
        <span class="inquiry-pre-datepicker-text desktop">Отчетен период</span>
        <div class="inquiry-datepicker" v-if="datePeriod !== 'none'">
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="mck">D</span>
              <input
                type="text"
                placeholder="От дата"
                v-model="formatedFromDate"
                :disabled="true"
              />
            </div>
          </div>
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="mck">D</span>
              <input
                type="text"
                placeholder="До дата"
                v-model="formatedToDate"
                :disabled="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inquiry-filters">
      <div class="inquiry-filters-inputs">
        <button class="btn btn-filter" @click="isSelectFiltersModalOpen = true">
          <span class="mck">g</span>
          Филтри
        </button>
        <!-- DESKTOP COMPANY  -->
        <div class="new-input-wrapper">
          <!-- <label>Отдел</label> -->
          <div class="new-input">
            <span class="mck icon--company">a</span>
            <!-- SELECTED -->
            <input
              type="text"
              placeholder="Отдел"
              v-model="inquiry.company.companyName"
              :disabled="true"
            />
            <span class="disabled">A</span>
          </div>
          <div
            class="new-input-dropdown new-input-dropdown--big"
            :class="{ 'new-input-dropdown-active': openedDropdown[2] }"
          >
            <ul>
              <li
                v-for="c in filteredCompanies()"
                :key="c._id"
                @click="selectCompany(c)"
              >
                {{ c.companyName }}
              </li>
            </ul>
          </div>
        </div>
        <!-- PROJECT -->
        <div class="new-input-wrapper">
          <!-- <label>Проект</label> -->
          <div class="new-input">
            <span class="mck icon--project">h</span>
            <!-- SELECTED -->
            <input
              type="text"
              placeholder="Проект"
              v-model="inquiry.project.projectName"
              :disabled="true"
            />
            <span class="disabled">A</span>
          </div>
          <div
            class="new-input-dropdown new-input-dropdown--big"
            :class="{ 'new-input-dropdown-active': openedDropdown[3] }"
          >
            <ul>
              <li
                v-for="p in filteredProjects()"
                :key="p._id"
                @click="selectProject(p)"
              >
                {{ p.projectName }}
              </li>
            </ul>
          </div>
        </div>
        <!-- PART -->
        <div class="new-input-wrapper">
          <!-- <label>Част</label> -->
          <div class="new-input">
            <span class="mck icon--part">i</span>
            <!-- SELECTED -->
            <input
              type="text"
              placeholder="Част"
              v-model="inquiry.part._id"
              :disabled="true"
            />
            <span class="disabled">A</span>
          </div>
          <div
            class="new-input-dropdown new-input-dropdown--big"
            :class="{ 'new-input-dropdown-active': openedDropdown[5] }"
          >
            <ul>
              <li
                v-for="p in filteredParts()"
                :key="p._id"
                @click="selectPart(p)"
              >
                {{ p._id }}
              </li>
            </ul>
          </div>
        </div>
        <!-- DEKTOP REPORTER -->
        <div class="new-input-wrapper">
          <!-- <label>Отчетник</label> -->
          <div class="new-input">
            <span class="mck icon--reporter">j</span>
            <!-- SELECTED -->
            <input
              type="text"
              placeholder="Отчетник"
              v-model="inquiry.reporter.name"
              :disabled="true"
            />
            <span class="disabled">A</span>
          </div>
          <div
            class="new-input-dropdown new-input-dropdown--big"
            :class="{ 'new-input-dropdown-active': openedDropdown[6] }"
          >
            <ul>
              <li
                v-for="r in filteredReporters()"
                :key="r._id"
                @click="selectReporter(r)"
              >
                {{ r.name }}
              </li>
            </ul>
          </div>
        </div>
        <!-- WORKER -->
        <div class="new-input-wrapper">
          <!-- <label>Работник</label> -->
          <div class="new-input">
            <span class="mck icon--worker">k</span>
            <!-- SELECTED -->
            <input
              type="text"
              placeholder="Работник"
              v-model="inquiry.worker.name"
              :disabled="true"
            />
            <span class="disabled">A</span>
          </div>
          <div
            class="new-input-dropdown new-input-dropdown--big"
            :class="{ 'new-input-dropdown-active': openedDropdown[7] }"
          >
            <ul>
              <li v-for="w in filteredWorkers()" :key="w._id">
                {{ w.name }}
              </li>
            </ul>
          </div>
        </div>
        <button
          v-if="!reports.length"
          class="btn btn-new"
          @click="getInquiry()"
        >
          Направи справка
        </button>
        <button
          class="btn btn-excel"
          :disabled="!reports.length"
          @click="exportToExcelFile()"
        >
          <span class="mck">E</span>
        </button>
      </div>
      <!-- <div class="inquiry-filters-btns">
        <div class="checkboxes-wrapper">
          <label class="checkbox-wrapper">
            Активни обекти
            <input
              type="checkbox"
              v-model="activeProjects"
              @change="selectActiveProjects()"
            />
            <span class="checkmark"></span>
          </label>
          <label class="checkbox-wrapper">
            Грешни отчети
            <input
              type="checkbox"
              v-model="inquiry.isInvalid"
              @change="selectInvalid()"
            />
            <span class="checkmark"></span>
          </label>
        </div>
        <button v-if="!reports.length" class="btn btn-new" @click="getInquiry()">Направи справка</button>
        <div v-else class="btns desktop">
          <button class="btn btn-excel" @click="exportToExcelFile()">
            <span class="mck">E</span>
            Експорт в Excel
          </button>
          <button class="btn btn-reset" @click="resetInquiry()">
            <span class="mck">F</span>
            Нулирай филтри
          </button>
        </div>
      </div> -->
    </div>
    <div class="inquiry-title-wrapper" v-if="isInquiryMade">
      <h3
        class="inquiry-title"
        :class="{ 'inquiry-title-invalid': !activeProjects }"
        ref="reports"
      >
        <span>Справка&nbsp;</span>
        <span v-if="inquiry.company._id">
          <span>за отдел&nbsp;</span>
          <strong>{{ inquiry.company.companyName }}</strong>
        </span>
        <span v-else>
          <span>
            по
            <span v-if="inquiry.isInvalid">грешни&nbsp;</span>
            <span v-if="inquiry.isPlanned">планирани</span>
            отчети за&nbsp;
          </span>
          <strong>
            всички
            <span v-if="!activeProjects">неактивни&nbsp;</span>отдели
          </strong>
        </span>
        <span v-if="inquiry.project._id">
          <span>, проект&nbsp;</span>
          <strong>{{ inquiry.project.projectName }}</strong>
        </span>
        <span v-if="inquiry.part._id">
          <span>, част&nbsp;</span>
          <strong>{{ inquiry.part._id }}&nbsp;</strong>
        </span>
        <span v-if="inquiry.reporter._id">
          <span>, отчетник&nbsp;</span>
          <strong>{{ inquiry.reporter.name }}</strong>
        </span>
        <span v-if="inquiry.worker._id">
          <span>, работник&nbsp;</span>
          <strong>{{ inquiry.worker.name }}</strong>
        </span>
        <template v-if="datePeriod === 'none'">
          <span>за <strong>всички времена</strong></span>
        </template>
        <template v-else>
          <span>за периода - от&nbsp;</span>
          <strong>{{ formatedFromDate }}</strong>
          <span>&nbsp;до&nbsp;</span>
          <strong>{{ formatedToDate }}</strong>
        </template>
        <strong
          v-if="
            !showWorkers &&
            showMaterials &&
            showMechanizations &&
            showRentedMechanizations
          "
          >, без включен Труд</strong
        >
        <strong
          v-else-if="
            showWorkers &&
            !showMaterials &&
            showMechanizations &&
            showRentedMechanizations
          "
          >, без включени Материали</strong
        >
        <strong
          v-else-if="
            showWorkers &&
            showMaterials &&
            !showMechanizations &&
            showRentedMechanizations
          "
          >, без включена Собствена механизация</strong
        >
        <strong
          v-else-if="
            showWorkers &&
            showMaterials &&
            showMechanizations &&
            !showRentedMechanizations
          "
          >, без включена Наета механизация</strong
        >
        <strong
          v-else-if="
            !showWorkers ||
            !showMaterials ||
            !showMechanizations ||
            !showRentedMechanizations
          "
        >
          , без включени
          <span v-if="!showWorkers">Труд</span>
          <span v-if="!showMechanizations || !showRentedMechanizations">
            <span v-if="!showWorkers && !showMaterials">,&nbsp;</span>
            <span v-if="!showWorkers && showMaterials">&nbsp;и&nbsp;</span>
            <template v-if="!showMechanizations">Собствена</template>
            <template v-if="!showMechanizations && !showRentedMechanizations"
              >и</template
            >
            <template v-if="!showRentedMechanizations">Наета</template>
            механизация
          </span>
          <span v-if="!showMaterials">
            <span
              v-if="
                !showWorkers || !showMechanizations || !showRentedMechanizations
              "
              >&nbsp;и&nbsp;</span
            >
            Материали
          </span>
        </strong>
      </h3>
      <!-- <h3 class="inquiry-title" :class="{ 'inquiry-title-invalid': !activeProjects }">
        <span>за периода - от&nbsp;</span>
        <strong>{{formatedFromDate}}</strong>
        <span>&nbsp;до&nbsp;</span>
        <strong>{{formatedToDate}}</strong>
      </h3>-->
    </div>
    <div class="no-reports" v-if="loading">
      <p>Справката се зарежда, моля изчакайте...</p>
    </div>
    <div
      class="no-reports"
      v-else-if="isInquiryMade && !reports.length"
      ref="no-reports"
    >
      <p>Няма добавени отчети за избраните параметри.</p>
    </div>
    <div class="reports" v-if="reports.length">
      <div class="reports-tabs">
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 3 }"
          @click="selectTab(3)"
        >
          <span>Отчети</span>
          <span v-if="!this.inquiry.worker._id">({{ reports.length }})</span>
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 4 }"
          @click="selectTab(4)"
        >
          <span>Собствена механизация</span>
          <span v-if="!this.inquiry.worker._id"
            >({{ totalMechanizationItems }})</span
          >
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 8 }"
          @click="selectTab(8)"
        >
          <span>Инструменти</span>
          <span v-if="!this.inquiry.worker._id"
            >({{ totalEquipmentItems }})</span
          >
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 7 }"
          @click="selectTab(7)"
        >
          <span>Наета механизация</span>
          <span v-if="!this.inquiry.worker._id"
            >({{ totalRentedMechanizationItems }})</span
          >
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 0 }"
          @click="selectTab(0)"
        >
          <span>Материали</span>
          <span v-if="!this.inquiry.worker._id"
            >({{ totalMaterialItems }})</span
          >
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 2 }"
          @click="selectTab(2)"
        >
          <span>Работници</span>
          <span>({{ totalWorkerItems }})</span>
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 5 }"
          @click="selectTab(5)"
          v-if="!this.inquiry.worker._id"
        >
          <span>Баланс (разходи и приходи)</span>
        </button>
        <button
          class="reports-tab"
          :class="{ 'reports-tab-active': activeTab === 6 }"
          @click="selectTab(6)"
          v-if="!this.inquiry.isPlanned"
        >
          <span>Планирано/Изпълнено</span>
        </button>
      </div>
      <div class="reports-content">
        <!-- REPORTS -->
        <div class="table-wrapper">
          <table class="table" ref="reportsTable" v-show="activeTab === 3">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Отдел</th>
                <th>Проект</th>
                <template v-if="showWorkers">
                  <th class="center">
                    Отчетени
                    <br />&nbsp;хора&nbsp;
                  </th>
                  <th class="center">
                    Общо отчетено
                    <br />&nbsp;време&nbsp;
                  </th>
                </template>
                <th class="center" v-if="showMechanizations">
                  Отчетени
                  <br />&nbsp; собствени механизации&nbsp;
                </th>
                <th class="center" v-if="showTools">
                  Отчетени
                  <br />&nbsp; инструменти&nbsp;
                </th>
                <th class="center" v-if="showRentedMechanizations">
                  Отчетени
                  <br />&nbsp; наети механизации&nbsp;
                </th>
                <th class="center" v-if="showMaterials">
                  Отчетени
                  <br />&nbsp;материали&nbsp;
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="report in reports"
                :key="`report-${report._id}`"
                @click="goToExternalReport(report._id)"
                :class="{
                  'tr-invalid': report.isInvalid,
                  'tr-planned': inquiry.isPlanned,
                }"
              >
                <td>
                  <span class="no-wrap">{{ report.date | formatDate }} г.</span>
                </td>
                <td>
                  <span>{{ report.createdBy.name }}</span>
                </td>
                <td class="td-company-name">
                  <img
                    class="td-invalid-flag"
                    v-if="report.isInvalid"
                    src="../assets/img/flag_yes.svg"
                    alt="invalid"
                  />
                  {{ report.company.companyName }}
                </td>
                <td>{{ report.project.projectName }}</td>
                <template v-if="showWorkers">
                  <td
                    class="center underline-hover"
                    :title="report.workersList"
                    v-if="showWorkers"
                  >
                    {{ report.workers.length }}
                  </td>
                  <td class="center">
                    <div class="worktime-indicator-wrapper">
                      <WorktimeTag :total="report.calculated" />
                    </div>
                  </td>
                </template>
                <td class="center" v-if="showMechanizations">
                  <template v-if="report.mechanizations">{{
                    report.mechanizations.length
                  }}</template>
                </td>
                <td class="center" v-if="showTools">
                  <template v-if="report.tools">{{
                    report.tools.length
                  }}</template>
                </td>
                <td class="center" v-if="showRentedMechanizations">
                  <template v-if="report.rentedMechanizations">{{
                    report.rentedMechanizations.length
                  }}</template>
                </td>
                <td class="center" v-if="showMaterials">
                  <template v-if="report.materials">{{
                    report.materials.length
                  }}</template>
                </td>
              </tr>
              <tr
                v-if="isInquiryMade && !reports.length"
                :class="{ 'tr-planned': inquiry.isPlanned }"
              >
                <td colspan="5" class="td-center">
                  Няма добавени отчети за избраните параметри.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- MECHANIZATIONS -->
        <div class="table-wrapper">
          <table class="table" ref="mechanizations" v-show="activeTab === 4">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Отдел</th>
                <th>Проект</th>
                <th>
                  Собствена&nbsp;
                  <br />Механизация
                </th>
                <th>Част</th>
                <th>Количество</th>
                <th>
                  Мерна&nbsp;
                  <br />единица
                </th>
                <th>
                  Обща&nbsp;
                  <br />цена в €
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="r in reports">
                <tr
                  v-for="m in r.mechanizations"
                  :key="`report-${r._id}-mechanization-${m._id}`"
                  @click="goToExternalReport(r._id)"
                  :class="{
                    'additional-row': m.isAdditional,
                    'tr-invalid': r.isInvalid,
                    'tr-planned': inquiry.isPlanned,
                  }"
                >
                  <td>
                    <span class="no-wrap">{{ r.date | formatDate }} г.</span>
                  </td>
                  <td>{{ r.createdBy.name }}</td>
                  <td>{{ r.company.companyName }}</td>
                  <td>{{ r.project.projectName }}</td>
                  <td
                    :class="{
                      'additional-td additional-td-mechanization':
                        m.isAdditional,
                    }"
                  >
                    {{ m.name }}
                  </td>
                  <td>{{ m.part }}</td>
                  <td>{{ m.items }}</td>
                  <td>{{ m.unit }}</td>
                  <td>{{ (+m.price * +m.items).toFixed(2) }}</td>
                </tr>
              </template>
              <tr
                v-if="isInquiryMade && !totalMechanizationItems"
                :class="{ 'tr-planned': inquiry.isPlanned }"
              >
                <td colspan="9" class="td-center">
                  Няма добавени собствени механизации за избраните параметри.
                </td>
              </tr>
              <tr class="sum-row" :class="{ 'tr-planned': inquiry.isPlanned }">
                <td colspan="8">
                  Обща сума за избраните собствени механизации:
                </td>
                <td>{{ totalMechanizations.toFixed(2) }} €</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- TOOLS -->
        <div class="table-wrapper">
          <table class="table" ref="tools" v-show="activeTab === 8">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Отдел</th>
                <th>Проект</th>
                <th>Инвентар</th>
                <th>Част</th>
                <th>Количество</th>
                <th>
                  Мерна&nbsp;
                  <br />единица
                </th>
                <th>
                  Обща&nbsp;
                  <br />цена в €
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="r in reports">
                <tr
                  v-for="m in r.tools"
                  :key="`report-${r._id}-equipment-${m._id}`"
                  @click="goToExternalReport(r._id)"
                  :class="{
                    'additional-row': m.isAdditional,
                    'tr-invalid': r.isInvalid,
                    'tr-planned': inquiry.isPlanned,
                  }"
                >
                  <td>
                    <span class="no-wrap">{{ r.date | formatDate }} г.</span>
                  </td>
                  <td>{{ r.createdBy.name }}</td>
                  <td>{{ r.company.companyName }}</td>
                  <td>{{ r.project.projectName }}</td>
                  <td
                    :class="{
                      'additional-td additional-td-mechanization':
                        m.isAdditional,
                    }"
                  >
                    {{ m.name }}
                  </td>
                  <td>{{ m.part }}</td>
                  <td>{{ m.items }}</td>
                  <td>{{ m.unit }}</td>
                  <td>{{ (+m.price * +m.items).toFixed(2) }}</td>
                </tr>
              </template>
              <tr
                v-if="isInquiryMade && !totalEquipmentItems"
                :class="{ 'tr-planned': inquiry.isPlanned }"
              >
                <td colspan="9" class="td-center">
                  Няма добавени инструменти за избраните параметри.
                </td>
              </tr>
              <tr class="sum-row" :class="{ 'tr-planned': inquiry.isPlanned }">
                <td colspan="8">Обща сума за избраните инструменти:</td>
                <td>{{ totalTools.toFixed(2) }} €</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- RENTED MECHANIZATIONS -->
        <div class="table-wrapper">
          <table
            class="table"
            ref="rentedMechanizations"
            v-show="activeTab === 7"
          >
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Отдел</th>
                <th>Проект</th>
                <th>
                  Наета&nbsp;
                  <br />механизация
                </th>
                <th>Част</th>
                <th>Количество</th>
                <th>
                  Мерна&nbsp;
                  <br />единица
                </th>
                <th>
                  Обща&nbsp;
                  <br />цена в €
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="r in reports">
                <tr
                  v-for="m in r.rentedMechanizations"
                  :key="`report-${r._id}-rentedMechanization-${m._id}`"
                  @click="goToExternalReport(r._id)"
                  :class="{
                    'additional-row': m.isAdditional,
                    'tr-invalid': r.isInvalid,
                    'tr-planned': inquiry.isPlanned,
                  }"
                >
                  <td>
                    <span class="no-wrap">{{ r.date | formatDate }} г.</span>
                  </td>
                  <td>{{ r.createdBy.name }}</td>
                  <td>{{ r.company.companyName }}</td>
                  <td>{{ r.project.projectName }}</td>
                  <td
                    :class="{
                      'additional-td additional-td-rentedMechanization':
                        m.isAdditional,
                    }"
                  >
                    {{ m.name }} ({{ m.landlord }})
                  </td>
                  <td>{{ m.part }}</td>
                  <td>{{ m.items }}</td>
                  <td>{{ m.unit }}</td>
                  <td>{{ (+m.price * +m.items).toFixed(2) }}</td>
                </tr>
              </template>
              <tr
                v-if="isInquiryMade && !totalRentedMechanizationItems"
                :class="{ 'tr-planned': inquiry.isPlanned }"
              >
                <td colspan="9" class="td-center">
                  Няма добавени собствени механизации за избраните параметри.
                </td>
              </tr>
              <tr class="sum-row" :class="{ 'tr-planned': inquiry.isPlanned }">
                <td colspan="8">
                  Обща сума за избраните собствени механизации:
                </td>
                <td>{{ totalRentedMechanizations.toFixed(2) }} €</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- MATERIALS -->
        <div class="table-wrapper">
          <table class="table" ref="materials" v-show="activeTab === 0">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Отдел</th>
                <th>Проект</th>
                <th>Материал</th>
                <th>Част</th>
                <th>Количество</th>
                <th>
                  Мерна&nbsp;
                  <br />единица
                </th>
                <th>
                  Обща&nbsp;
                  <br />цена в €
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="report in reports">
                <tr
                  v-for="material in report.materials"
                  :key="`report-${report._id}-material-${material._id}`"
                  @click="goToExternalReport(report._id)"
                  :class="{
                    'additional-row': material.isAdditional,
                    'tr-invalid': report.isInvalid,
                    'tr-planned': inquiry.isPlanned,
                  }"
                >
                  <td>
                    <span class="no-wrap"
                      >{{ report.date | formatDate }} г.</span
                    >
                  </td>
                  <td>{{ report.createdBy.name }}</td>
                  <td>{{ report.company.companyName }}</td>
                  <td>{{ report.project.projectName }}</td>
                  <td
                    :class="{
                      'additional-td additional-td-material':
                        material.isAdditional,
                    }"
                  >
                    {{ material.name }}
                  </td>
                  <td>{{ material.part }}</td>
                  <td>{{ material.items }}</td>
                  <td>{{ material.unit }}</td>
                  <td>{{ (+material.price * +material.items).toFixed(2) }}</td>
                </tr>
              </template>
              <tr
                v-if="isInquiryMade && !totalMaterialItems"
                :class="{ 'tr-planned': inquiry.isPlanned }"
              >
                <td colspan="9" class="td-center">
                  Няма добавени материали за избраните параметри.
                </td>
              </tr>
              <tr class="sum-row" :class="{ 'tr-planned': inquiry.isPlanned }">
                <td colspan="8">Обща сума за избраните материали:</td>
                <td>{{ totalMaterials.toFixed(2) }} €</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- WORKERS -->
        <div class="table-wrapper">
          <table class="table" ref="workers" v-show="activeTab === 2">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Отчетник</th>
                <th>Работник</th>
                <th>Отдел</th>
                <th>Длъжност</th>
                <th>Проект</th>
                <th>Част</th>
                <th>НРВ</th>
                <th class="no-wrap">ИРВ 1</th>
                <th class="no-wrap">ИРВ 2</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="report in reports">
                <tr
                  v-for="(worker, i) in report.workers"
                  :key="`${i}-report-${report._id}-worker-${worker._id}`"
                  @click="goToExternalReport(report._id)"
                  :class="{
                    'tr-invalid': report.isInvalid,
                    'tr-planned': inquiry.isPlanned,
                  }"
                >
                  <td>
                    <span class="no-wrap"
                      >{{ report.date | formatDate }} г.</span
                    >
                  </td>
                  <td>{{ report.createdBy.name }}</td>
                  <td>{{ worker.name }}</td>
                  <td>{{ report.company.companyName }}</td>
                  <td>{{ worker.position ? worker.position.name : "" }}</td>
                  <td>{{ report.project.projectName }}</td>
                  <td>{{ worker.part }}</td>
                  <td>
                    <span v-if="worker.calculated">{{
                      worker.calculated.normal
                    }}</span>
                  </td>
                  <td>
                    <span v-if="worker.calculated">{{
                      worker.calculated.overtime
                    }}</span>
                  </td>
                  <td>
                    <span v-if="worker.calculated">{{
                      worker.calculated.holiday
                    }}</span>
                  </td>
                </tr>
              </template>
              <tr
                v-if="isInquiryMade && !totalWorkerItems"
                :class="{ 'tr-planned': inquiry.isPlanned }"
              >
                <td colspan="10" class="td-center">
                  Няма добавени работници за избраните параметри.
                </td>
              </tr>
              <tr class="sum-row" :class="{ 'tr-planned': inquiry.isPlanned }">
                <td colspan="7">Общо изработени часове:</td>
                <td>{{ totalWorkers.normal }}</td>
                <td>{{ totalWorkers.overtime }}</td>
                <td>{{ totalWorkers.holiday }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- BALANCE -->
        <div class="table-wrapper">
          <InquiryBalance
            :data="reports"
            :inquiry="inquiry"
            :isInquiryMade="isInquiryMade"
            :activeProjects="activeProjects"
            :showWorkers="showWorkers"
            :showMaterials="showMaterials"
            :showMechanizations="showMechanizations"
            :showTools="showTools"
            :showRentedMechanizations="showRentedMechanizations"
            :showExternalProjects="showExternalProjects"
            :showExternalWorkers="showExternalWorkers"
            :external="true"
            v-show="activeTab === 5"
          />
        </div>
        <!-- PLAN/REAL -->
        <div class="table-wrapper">
          <table class="table" ref="plannedAndReal" v-show="activeTab === 6">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Планирано от</th>
                <th class="padding-for-tag">
                  <p class="space-between">
                    <span>Изпълнители</span>
                    <span> <span class="regular">План</span> / Отчет </span>
                  </p>
                </th>
                <th class="padding-for-tag">
                  <p class="space-between">
                    <span>Собствена механизация</span>
                    <span> <span class="regular">План</span> / Отчет </span>
                  </p>
                </th>
                <th class="padding-for-tag">
                  <p class="space-between">
                    <span>Наета механизация</span>
                    <span> <span class="regular">План</span> / Отчет </span>
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="r in reports">
                <tr
                  v-if="r.initAsPlanned"
                  :key="`plan-real-${r._id}`"
                  @click="goToExternalReport(r._id)"
                  class="tr-padding"
                  :class="{ 'tr-invalid': r.isInvalid }"
                >
                  <td>
                    <span class="no-wrap">{{ r.date | formatDate }} г.</span>
                  </td>
                  <td>
                    <span>{{ r.createdBy.name }}</span>
                  </td>
                  <td>
                    <p
                      class="space-between"
                      v-for="(w, i) in r.workers"
                      :key="`p-r-worker-${i}`"
                    >
                      <span>{{ w.name }}</span>
                      <span class="no-wrap space-between border-right">
                        {{ w.calculated.planned || 0 }} ч.&nbsp;/&nbsp;
                        <strong>{{ w.calculated.total }} ч.</strong>
                        <PercentTag
                          :planned="w.calculated.planned"
                          :real="w.calculated.total"
                        />
                      </span>
                    </p>
                  </td>
                  <td class="td--third">
                    <p
                      class="space-between border-right"
                      v-for="(a, i) in r.activities"
                      :key="`p-r-activity-${i}`"
                    >
                      <span>{{ a.name }}</span>
                      <span class="no-wrap space-between">
                        {{ a.plannedItems || 0 }} {{ a.unit }}&nbsp;/&nbsp;
                        <strong>{{ a.items || 0 }} {{ a.unit }}</strong>
                        <PercentTag
                          :planned="a.plannedItems"
                          :real="a.items"
                          :red="a.plannedItems > a.items"
                        />
                      </span>
                    </p>
                  </td>
                  <td class="td--third">
                    <p
                      class="space-between"
                      v-for="(m, i) in r.mechanizations"
                      :key="`p-r-mechanization-${i}`"
                    >
                      <span>{{ m.name }}</span>
                      <span class="no-wrap space-between">
                        {{ m.plannedItems || 0 }} {{ m.unit }}&nbsp;/&nbsp;
                        <strong>{{ m.items || 0 }} {{ m.unit }}</strong>
                        <PercentTag :planned="m.plannedItems" :real="m.items" />
                      </span>
                    </p>
                  </td>
                  <td class="td--third">
                    <p
                      class="space-between"
                      v-for="(m, i) in r.rentedMechanizations"
                      :key="`p-r-rentedMechanizations-${i}`"
                    >
                      <span>{{ m.name }}</span>
                      <span class="no-wrap space-between">
                        {{ m.plannedItems || 0 }} {{ m.unit }}&nbsp;/&nbsp;
                        <strong>{{ m.items || 0 }} {{ m.unit }}</strong>
                        <PercentTag :planned="m.plannedItems" :real="m.items" />
                      </span>
                    </p>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- MOBILE BUTTONS -->
    <footer class="modal-footer mobile" v-if="reports.length" ref="footer">
      <div class="btns mobile">
        <!-- UP -->
        <span
          class="new-content-data-item-toggle-circle mobile top"
          @click="scrollToTop()"
        >
          <span class="mck">f</span>
        </span>
        <!-- NEW Inquiry -->
        <span class="new-content-data-item-toggle-circle mobile">
          <span class="mck">L</span>
        </span>
        <!-- EXPORT IN EXCEL -->
        <span
          class="new-content-data-item-toggle-circle mobile excel"
          @click="exportToExcelFile()"
        >
          <span class="mck">E</span>
        </span>
      </div>
    </footer>
    <transition name="fade">
      <SelectFiltersModal
        v-if="isSelectFiltersModalOpen"
        @close="isSelectFiltersModalOpen = false"
        @save="handleSelectFilters"
        :isInvalid="inquiry.isInvalid"
        :isPlanned="inquiry.isPlanned"
        :activeProjects="activeProjects"
        :showMechanizations="showMechanizations"
        :showTools="showTools"
        :showRentedMechanizations="showRentedMechanizations"
        :showMaterials="showMaterials"
        :showWorkers="showWorkers"
        :showExternalProjects="showExternalProjects"
        :showExternalWorkers="showExternalWorkers"
      />
    </transition>
  </div>
</template>

<script>
import hours from "./mixins/hours.js";
import { bg } from "vuejs-datepicker/dist/locale";
import { format } from "date-fns";
import * as XLSX from 'xlsx';
import { mapGetters } from "vuex";
import WorktimeTag from "./shared/WorktimeTag";
import PercentTag from "./shared/PercentTag";
import InquiryBalance from "./InquiryBalance";
import SelectFiltersModal from "./shared/SelectFiltersModal";
export default {
  components: {
    WorktimeTag,
    PercentTag,
    InquiryBalance,
    SelectFiltersModal,
  },
  mixins: [hours],
  data() {
    return {
      // Vars for select v-model
      company: "",
      project: "",
      part: "",
      reporter: "",
      worker: "",
      bg: bg,
      formatedFromDate: null,
      formatedToDate: null,
      isSelectFiltersModalOpen: false,
      activeTab: 3,
      datePeriod: "today",
      // DROPDOWNS
      openedDropdown: [false, false, false, false, false, false, false, false],
      // SEARCH
      loading: false,
      searchCompanies: "",
      searchProjects: "",
      searchParts: "",
      searchReporters: "",
      searchWorkers: "",
      companies: [],
      projects: [],
      parts: [],
      reporters: [],
      workers: [],
      reports: [],
      totalMechanizations: 0,
      totalTools: 0,
      totalRentedMechanizations: 0,
      totalMaterials: 0,
      totalWorkers: {
        normal: 0,
        overtime: 0,
        holiday: 0,
      },
      totalMechanizationItems: 0,
      totalEquipmentItems: 0,
      totalRentedMechanizationItems: 0,
      totalMaterialItems: 0,
      totalActivityItems: 0,
      totalWorkerItems: 0,
      isInquiryMade: false,
      queryObject: {},
      activeProjects: true,
      overtimeProjects: false,
      showMechanizations: true,
      showTools: true,
      showRentedMechanizations: true,
      showWorkers: true,
      showMaterials: true,
      showExternalProjects: false,
      showExternalWorkers: false,
      inquiry: {
        fromDate: "",
        toDate: "",
        company: {
          _id: "",
          companyName: "",
        },
        project: {
          _id: "",
          projectName: "",
        },
        part: {
          _id: "",
        },
        reporter: {
          _id: "",
          name: "",
        },
        worker: {
          _id: "",
          name: "",
        },
        isInvalid: false,
        isPlanned: false,
      },
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {
    // 'inquiry.fromDate'(to, from) {
    "inquiry.fromDate"(to) {
      // eslint-disable-next-line
      // if (!!from) {
      this.resetReports();
      // }
      if (to !== null) {
        this.inquiry.fromDate.setHours(0, 0, 0, 0);
        this.$set(
          this.queryObject,
          "fromDate",
          this.inquiry.fromDate.toISOString()
        );
        this.formatedFromDate= format(new Date(this.inquiry.fromDate), 'dd/MM/yyyy')
      } else {
        this.formatedFromDate = null;
        delete this.queryObject.fromDate;
      }
    },
    // 'inquiry.toDate'(to, from) {
    "inquiry.toDate"(to) {
      // eslint-disable-next-line
      // if (!!from) {
      this.resetReports();
      // }
      if (to !== null) {
        this.inquiry.toDate.setHours(23, 59, 59, 999);
        this.$set(
          this.queryObject,
          "toDate",
          this.inquiry.toDate.toISOString()
        );
        this.formatedToDate= format(new Date(this.inquiry.toDate), 'dd/MM/yyyy')
      } else {
        this.formatedToDate = null;
        delete this.queryObject.toDate;
      }
    },
  },
  methods: {
    setDays(d) {
      const date = new Date();
      // set first day of previous month
      this.inquiry.fromDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + d
      );
      this.inquiry.fromDate.setHours(0, 0, 0, 0);
      // set last day of previous month
      this.inquiry.toDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + d
      );
      this.inquiry.toDate.setHours(23, 59, 59, 999);
    },
    exportToExcelFile() {
      const wscols = [
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 },
      ];

      const config = { dateNF: "dd/mm/yyyy" };
      // Convert Table to Worksheet

      if (!this.inquiry.worker._id) {
        const reportsWorksheet = XLSX.utils.table_to_sheet(
          this.$refs["reportsTable"],
          config
        );
        const mechanizationsWorksheet = XLSX.utils.table_to_sheet(
          this.$refs["mechanizations"],
          config
        );
        const rentedMechanizationsWorksheet = XLSX.utils.table_to_sheet(
          this.$refs["rentedMechanizations"],
          config
        );
        const materialsWorksheet = XLSX.utils.table_to_sheet(
          this.$refs["materials"],
          config
        );
        const workersWorksheet = XLSX.utils.table_to_sheet(
          this.$refs["workers"],
          config
        );
        // Define New Workbook
        const new_workbook = XLSX.utils.book_new();

        reportsWorksheet["!cols"] = wscols;
        mechanizationsWorksheet["!cols"] = wscols;
        rentedMechanizationsWorksheet["!cols"] = wscols;
        materialsWorksheet["!cols"] = wscols;
        workersWorksheet["!cols"] = wscols;

        // Append Worksheet
        XLSX.utils.book_append_sheet(new_workbook, reportsWorksheet, "Отчети");
        XLSX.utils.book_append_sheet(
          new_workbook,
          mechanizationsWorksheet,
          "Собствена механизация"
        );
        XLSX.utils.book_append_sheet(
          new_workbook,
          rentedMechanizationsWorksheet,
          "Наета механизация"
        );
        XLSX.utils.book_append_sheet(
          new_workbook,
          materialsWorksheet,
          "Материали"
        );
        XLSX.utils.book_append_sheet(
          new_workbook,
          workersWorksheet,
          "Работници"
        );
        // Save File
        XLSX.writeFile(
          new_workbook,
          `Справка-${this.formatedFromDate ? this.formatedFromDate : "-"}-${
            this.formatedToDate ? this.formatedToDate : "-"
          }.xlsx`
        );
      } else {
        const workersWorksheet = XLSX.utils.table_to_sheet(
          this.$refs["workers"],
          config
        );
        // Define New Workbook
        const new_workbook = XLSX.utils.book_new();

        workersWorksheet["!cols"] = wscols;

        // Append Worksheet
        XLSX.utils.book_append_sheet(
          new_workbook,
          workersWorksheet,
          `${this.inquiry.worker.name}`
        );
        // Save File

        XLSX.writeFile(
          new_workbook,
          `Справка-за-${this.inquiry.worker.name}-${this.formatedFromDate}-${this.formatedToDate}.xlsx`
        );
      }
    },
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    // Close dropdown. Depends on index (hard coded in template)
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    selectTab(num) {
      if (this.inquiry.worker._id) {
        this.activeTab = 2;
      } else this.activeTab = num;
    },
    // FILTERED RESULTS WHEN SEARCHING
    filteredCompanies() {
      if (this.companies.length) {
        return this.companies.filter((c) => {
          return c.companyName
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      }
    },
    filteredProjects() {
      if (this.projects.length) {
        return this.projects.filter((p) => {
          return p.projectName
            .toLowerCase()
            .includes(this.searchProjects.toLowerCase());
        });
      }
    },
    filteredParts() {
      if (this.parts.length) {
        return this.parts.filter((p) => {
          return p._id
            ? p._id.toLowerCase().includes(this.searchParts.toLowerCase())
            : false;
        });
      }
    },
    filteredReporters() {
      if (this.reporters.length) {
        return this.reporters.filter((r) => {
          return r.name
            .toLowerCase()
            .includes(this.searchReporters.toLowerCase());
        });
      }
    },
    filteredWorkers() {
      if (this.workers.length) {
        return this.workers.filter((w) => {
          return w.name
            .toLowerCase()
            .includes(this.searchWorkers.toLowerCase());
        });
      }
    },
    // RESETS
    resetSelectedCompany() {
      this.inquiry.company = {
        _id: "",
        companyName: "",
      };
      this.company = "";
      delete this.queryObject.company;
      delete this.queryObject.companyName;
      this.resetSelectedProject();
    },
    resetSelectedProject() {
      this.inquiry.project = {
        _id: "",
        projectName: "",
      };
      this.project = "";
      delete this.queryObject.project;
      delete this.queryObject.projectName;
      this.resetSelectedPart();
    },
    resetSelectedPart() {
      this.resetReports();
      this.inquiry.part = {
        _id: "",
      };
      this.part = "";
      delete this.queryObject.part;
    },
    resetSelectedReporter() {
      this.resetReports();
      this.inquiry.reporter = {
        _id: "",
        name: "",
      };
      this.reporter = "";
      delete this.queryObject.reporter;
      delete this.queryObject.reporterName;
    },
    resetSelectedWorker() {
      this.resetReports();
      this.inquiry.worker = {
        _id: "",
        name: "",
      };
      this.reporter = "";
      delete this.queryObject.worker;
      delete this.queryObject.workerName;
    },
    resetReports() {
      this.reports = [];
      this.isInquiryMade = false;
    },
    // SELECTS
    selectCompany(c) {
      this.resetReports();
      this.inquiry.company = c;
      this.queryObject.company = c._id;
      this.queryObject.companyName = c.companyName;
    },
    selectProject(p) {
      this.resetReports();
      this.inquiry.project = p;
      this.queryObject.project = p._id;
      this.queryObject.projectName = p.projectName;
    },
    selectPart(p) {
      this.resetReports();
      this.inquiry.part = p;
      this.queryObject.part = p._id;
    },
    selectReporter(r) {
      this.resetReports();
      this.inquiry.reporter = r;
      this.queryObject.reporter = r._id;
      this.queryObject.reporterName = r.name;
    },
    selectWorker(w) {
      this.resetReports();
      this.inquiry.worker = w;
      this.queryObject.worker = w._id;
      this.queryObject.workerName = w.name;
    },
    selectInvalid() {
      this.resetReports();
      this.queryObject.isInvalid = this.inquiry.isInvalid;
    },
    selectPlanned() {
      this.resetReports();
      this.queryObject.isPlanned = this.inquiry.isPlanned;
    },
    selectActiveProjects() {
      this.resetReports();
      this.resetSelectedCompany();
      this.queryObject.active = this.activeProjects;
    },
    handleSelectFilters(e) {
      if (e.activeProjects !== this.activeProjects) {
        this.activeProjects = e.activeProjects;
        this.selectActiveProjects();
      }
      if (e.isInvalid !== this.inquiry.isInvalid) {
        this.inquiry.isInvalid = e.isInvalid;
        this.selectInvalid();
      }
      if (e.isPlanned !== this.inquiry.isPlanned) {
        this.inquiry.isPlanned = e.isPlanned;
        this.selectPlanned();
      }
      if (e.showMechanizations !== this.showMechanizations) {
        this.showMechanizations = e.showMechanizations;
        this.resetReports();
        this.queryObject.showMechanizations = this.showMechanizations;
      }
      if (e.showTools !== this.showTools) {
        this.showTools = e.showTools;
        this.resetReports();
        this.queryObject.showTools = this.showTools;
      }
      if (e.showRentedMechanizations !== this.showRentedMechanizations) {
        this.showRentedMechanizations = e.showRentedMechanizations;
        this.resetReports();
        this.queryObject.showRentedMechanizations =
          this.showRentedMechanizations;
      }
      if (e.showWorkers !== this.showWorkers) {
        this.showWorkers = e.showWorkers;
        this.resetReports();
        this.queryObject.showWorkers = this.showWorkers;
      }
      if (e.showMaterials !== this.showMaterials) {
        this.showMaterials = e.showMaterials;
        this.resetReports();
        this.queryObject.showMaterials = this.showMaterials;
      }
      if (e.showExternalProjects !== this.showExternalProjects) {
        this.showExternalProjects = e.showExternalProjects;
        this.resetReports();
        this.queryObject.showExternalProjects = this.showExternalProjects;
      }
      if (e.showExternalWorkers !== this.showExternalWorkers) {
        this.showExternalWorkers = e.showExternalWorkers;
        this.resetReports();
        this.queryObject.showExternalWorkers = this.showExternalWorkers;
      }
      this.isSelectFiltersModalOpen = false;
    },
    getTotalMechanizations() {
      let sum = 0;
      this.totalMechanizationItems = 0;
      if (this.reports.length) {
        this.reports.forEach((r) => {
          if (r.mechanizations) {
            r.mechanizations.forEach((m) => {
              this.totalMechanizationItems++;
              sum += +m.items * +m.price;
            });
          }
        });
      }
      this.totalMechanizations = sum;
    },
    gettotalTools() {
      let sum = 0;
      this.totalEquipmentItems = 0;
      if (this.reports.length) {
        this.reports.forEach((r) => {
          if (r.tools) {
            r.tools.forEach((m) => {
              this.totalEquipmentItems++;
              sum += +m.items * +m.price;
            });
          }
        });
      }
      this.totalTools = sum;
    },
    getTotalRentedMechanizations() {
      let sum = 0;
      this.totalRentedMechanizationItems = 0;
      if (this.reports.length) {
        this.reports.forEach((r) => {
          if (r.rentedMechanizations) {
            r.rentedMechanizations.forEach((m) => {
              this.totalRentedMechanizationItems++;
              sum += +m.items * +m.price;
            });
          }
        });
      }
      this.totalRentedMechanizations = sum;
    },
    getTotalMaterials() {
      let sum = 0;
      this.totalMaterialItems = 0;
      if (this.reports.length) {
        this.reports.forEach((r) => {
          if (r.materials) {
            r.materials.forEach((m) => {
              this.totalMaterialItems++;
              sum += +m.items * +m.price;
            });
          }
        });
      }
      this.totalMaterials = sum;
    },
    getTotalWorkers() {
      let sum = {
        normal: 0,
        overtime: 0,
        holiday: 0,
      };
      this.totalWorkerItems = 0;
      if (this.reports.length) {
        this.reports.forEach((r) => {
          if (r.workers) {
            this.$set(r, "calculated", { normal: 0, overtime: 0, holiday: 0 });
            r.workers.forEach((w) => {
              this.totalWorkerItems++;

              const calc = this.calculateHours(r.date, w.startHour, w.endHour);

              sum.holiday += calc.holiday;
              sum.normal += calc.normal;
              sum.overtime += calc.overtime;

              if (w.plannedStartHour && w.plannedEndHour) {
                calc.planned = this.calculateHours(
                  r.date,
                  w.plannedStartHour,
                  w.plannedEndHour
                ).total;
              }

              this.$set(w, "calculated", calc);

              this.$set(
                r.calculated,
                "holiday",
                r.calculated.holiday + calc.holiday
              );
              this.$set(
                r.calculated,
                "normal",
                r.calculated.normal + calc.normal
              );
              this.$set(
                r.calculated,
                "overtime",
                r.calculated.overtime + calc.overtime
              );
            });
          }
        });
      }
      this.totalWorkers = sum;
    },
    // REQUESTS
    // if there are queries, load the existing parameters and assign them to the empty queryObject
    // TODO: refactor
    loadQueries(query) {
      if (Object.keys(query).length) {
        if (query.fromDate) {
          this.inquiry.fromDate = new Date(query.fromDate);
          this.queryObject.fromDate = query.fromDate;
        } else {
          this.inquiry.fromDate = null;
          delete this.queryObject.fromDate;
        }
        if (query.toDate) {
          this.inquiry.toDate = new Date(query.toDate);
          this.queryObject.toDate = query.toDate;
        } else {
          this.inquiry.toDate = null;
          delete this.queryObject.toDate;
        }
        if (query.company) {
          this.inquiry.company._id = query.company;
          this.queryObject.company = query.company;
        }
        if (query.companyName) {
          this.inquiry.company.companyName = query.companyName;
          this.queryObject.companyName = query.companyName;
        }
        if (query.project) {
          this.inquiry.project._id = query.project;
          this.queryObject.project = query.project;
        }
        if (query.projectName) {
          this.inquiry.project.projectName = query.projectName;
          this.queryObject.projectName = query.projectName;
        }
        if (query.part) {
          this.inquiry.part._id = query.part;
          this.queryObject.part = query.part;
        }
        if (query.reporter) {
          this.inquiry.reporter._id = query.reporter;
          this.queryObject.reporter = query.reporter;
        }
        if (query.reporterName) {
          this.inquiry.reporter.name = query.reporterName;
          this.queryObject.reporterName = query.reporterName;
        }
        if (query.worker) {
          this.inquiry.worker._id = query.worker;
          this.queryObject.worker = query.worker;
        }
        if (query.workerName) {
          this.inquiry.worker.name = query.workerName;
          this.queryObject.workerName = query.workerName;
        }
        if (query.period) {
          this.datePeriod = query.period;
          this.queryObject.period = query.period;
        }
        if (query.isInvalid) {
          const isInvalid = query.isInvalid == "true" ? true : false;
          this.inquiry.isInvalid = isInvalid;
          this.queryObject.isInvalid = isInvalid;
        }
        if (query.isPlanned) {
          const isPlanned = query.isPlanned == "true" ? true : false;
          this.inquiry.isPlanned = isPlanned;
          this.queryObject.isPlanned = isPlanned;
        }
        if (query.active) {
          const active = query.active == "true" ? true : false;
          this.activeProjects = active;
          this.queryObject.active = active;
        }
        if (query.showMechanizations) {
          const show = query.showMechanizations == "true" ? true : false;
          this.showMechanizations = show;
          this.queryObject.showMechanizations = show;
        }
        if (query.showTools) {
          const show = query.showTools == "true" ? true : false;
          this.showTools = show;
          this.queryObject.showTools = show;
        }
        if (query.showRentedMechanizations) {
          const show = query.showRentedMechanizations == "true" ? true : false;
          this.showRentedMechanizations = show;
          this.queryObject.showRentedMechanizations = show;
        }
        if (query.showWorkers) {
          const show = query.showWorkers == "true" ? true : false;
          this.showWorkers = show;
          this.queryObject.showWorkers = show;
        }
        if (query.showMaterials) {
          const show = query.showMaterials == "true" ? true : false;
          this.showMaterials = show;
          this.queryObject.showMaterials = show;
        }
        if (query.showExternalProjects) {
          const show = query.showExternalProjects == "true" ? true : false;
          this.showExternalProjects = show;
          this.queryObject.showExternalProjects = show;
        }
        if (query.showExternalWorkers) {
          const show = query.showExternalWorkers == "true" ? true : false;
          this.showExternalWorkers = show;
          this.queryObject.showExternalWorkers = show;
        }

        this.getInquiry();
      }
    },
    getWorkersList(r) {
      let workers = [];
      for (let w of r.workers) {
        workers.push(w.name);
      }
      return workers.join(", ");
    },
    getInquiry() {
      this.$store.dispatch("startLoading");
      this.loading = true;
      this.$router.push({ query: this.queryObject });
      this.isInquiryMade = true;
      this.reports = [];
      let url = `${process.env.VUE_APP_BASE_URI}/report/inquiry`;
      url += `/${this.inquiry.company._id ? this.inquiry.company._id : 0}`;
      url += `/${this.inquiry.project._id ? this.inquiry.project._id : 0}`;
      url += `/${
        this.inquiry.part._id ? encodeURIComponent(this.inquiry.part._id) : 0
      }`;
      url += `/${this.inquiry.reporter._id ? this.inquiry.reporter._id : 0}`;
      url += `/${this.inquiry.worker._id ? this.inquiry.worker._id : 0}`;
      url += `/${
        this.inquiry.fromDate ? this.inquiry.fromDate.toISOString() : 0
      }`;
      url += `/${this.inquiry.toDate ? this.inquiry.toDate.toISOString() : 0}`;
      url += `/${this.inquiry.isInvalid}`;
      url += `/${this.activeProjects}`;
      url += `?mechanizations=${this.showMechanizations}`;
      url += `&tools=${this.showTools}`;
      url += `&rentedMechanizations=${this.showRentedMechanizations}`;
      url += `&workers=${this.showWorkers}`;
      url += `&materials=${this.showMaterials}`;
      url += `&materials=${this.showExternalWorkers}`;
      url += `&externalProjects=${this.showExternalProjects}`;
      url += `&externalWorkers=${this.showExternalWorkers}`;
      url += `&planned=${this.inquiry.isPlanned}`;
      url += `&externalInquiry=true`;

      this.$http.get(url).then((response) => {
        this.reports = response.data;
        if (this.inquiry.worker._id) {
          this.activeTab = 2;
        } else if (this.inquiry.isPlanned) {
          this.activeTab = 3;
        }

        if (this.showWorkers) {
          this.reports.map((r) => {
            r.workersList = this.getWorkersList(r);
          });
        }

        this.getTotalMechanizations();
        this.gettotalTools();
        this.getTotalRentedMechanizations();
        this.getTotalMaterials();
        this.getTotalWorkers();
        this.$store.dispatch("stopLoading");
        this.loading = false;
      });
    },
    scrollToTop() {
      this.$refs["top"].scrollIntoView({ behavior: "smooth" });
    },
    goToExternalReport(id) {
      window.open(`/external-reports/${id}`, "_blank");
    },
  },
  mounted() {
    if (this.$route.query.period !== "none") {
      this.setDays(0);
    }
    this.loadQueries(this.$route.query);
  },
};
</script>

<style scoped>
.inquiry {
  padding: 10px 20px;
}
.inquiry-header {
  align-items: center;
  display: flex;
  height: 30px;
  justify-content: space-between;
}
.switch {
  margin: 0 8px;
}
.inquiry-header-controlls {
  align-items: center;
  display: flex;
}
.inquiry-pre-datepicker-text {
  color: #373737;
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  margin-right: 20px;
}
.inquiry-datepicker {
  border-radius: 4px;
  display: flex;
  position: relative;
  width: 330px;
  padding: 10px 0;
}
.inquiry-datepicker .new-input-wrapper {
  background-color: #fff;
  margin: 0;
  width: 50%;
}
.inquiry-datepicker .new-input-wrapper:first-child {
  border: 1px solid #dcdcdc;
  border-right: none;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.inquiry-datepicker .new-input-wrapper:nth-child(2) {
  border: 1px solid #dcdcdc;
  border-left: none;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
.inquiry-datepicker .new-input {
  background-color: transparent;
  margin: 0;
}
.inquiry-datepicker .new-input input {
  background-color: transparent;
  height: 30px;
  cursor: pointer;
}
.inquiry-datepicker .new-input input:not(:focus) {
  border: 1px solid transparent;
}
.inquiry-datepicker .new-input input:focus {
  background-color: #f4f4f4;
  border: 1px solid var(--color-main);
}
.inquiry-datepicker .new-input .mck {
  color: #8d3506;
}
/* .inquiry-datepicker .datepicker-dropdown { */
/* background-color: #ccd1e3; */
/* } */
.inquiry-header-controlls .btns {
  align-items: center;
}
.inquiry-filters {
  background-color: #fff;
  border-radius: 4px;
  margin-top: 10px;
  padding: 5px;
}
.inquiry-filters--normativ {
  padding: 15px 25px;
}
.inquiry-filters-inputs {
  display: flex;
}
.inquiry-filters-inputs .new-input-wrapper:last-of-type {
  margin-right: 5px;
}
.inquiry-filters-btns {
  align-items: center;
  display: flex;
  justify-content: space-between;
  /* margin-top: 5px; */
}
.inquiry-filters--normativ .inquiry-filters-btns {
  margin-top: 0;
}
.inquiry-filters-btns .checkboxes {
  display: flex;
}
.checkboxes-wrapper {
  display: flex;
}
.inquiry-filters-btns .checkbox-wrapper {
  margin-left: 0;
  margin-right: 15px;
}
.checkbox-wrapper .checkmark {
  background-color: #f4f4f4;
}
.checkbox-wrapper:hover input ~ .checkmark {
  background-color: #fff;
}
.checkbox-wrapper:hover input:checked ~ .checkmark {
  background-color: var(--color-main);
}
.inquiry-filters-btns .btn {
  margin: 0;
}
.inquiry-filters-btns .btn-excel {
  margin-right: 10px;
}
.new-input-wrapper {
  margin-right: 10px;
}
.new-input-wrapper .new-input {
  margin: 0;
}
.new-input input:not(:focus) {
  border: 1px solid #dcdcdc;
}
.icon--company {
  color: #d67e00;
}
.icon--project {
  color: #a1260d;
}
.icon--part {
  color: #047bcc;
}
.icon--reporter {
  color: #652d90;
}
.icon--worker {
  color: #e65100;
}
.new-input-dropdown {
  top: calc(100% + 5px);
}
.inquiry-filters-inputs .btn {
  font-size: 12px;
  height: 35px;
  padding: 0 10px;
  white-space: nowrap;
  margin: 0 5px 0 0;
  /* min-width: 130px; */
}
.inquiry-filters-inputs .btn-excel {
  margin: 0;
  width: initial;
}
.inquiry-filters-inputs .btn-excel .mck {
  font-size: 20px;
  margin: 0;
}
/* CONTENT */
.reports-tabs {
  display: flex;
  font-weight: 700;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: -1px;
  position: relative;
}
.reports-tab {
  align-items: center;
  background-color: #ccd1e3;
  border: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  height: 25px;
  justify-content: center;
  margin: 0 2px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  width: 25%;
}
.reports-tab span:first-child {
  margin-right: 2px;
}
.reports-tab:first-child {
  margin-left: 0;
}
.reports-tab:last-child {
  margin-right: 0;
}
.reports-tab:hover {
  background-color: #d4d8e6;
}
.reports-tab-active {
  background-color: #fff;
  border: 1px solid #ccd1e3;
  border-bottom: 1px solid #fff;
}
.reports-tab-active:hover {
  background-color: #fff;
}
.reports-content {
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #ccd1e3;
  padding: 0 10px;
}
.reports-content .table tbody tr:not(.tr-planned) {
  background-color: #f0f0f7;
}
/* .reports-content .table tbody td {
  padding: 10px;
} */
.reports-content .table .td-company-name {
  position: relative;
  padding: 0 20px;
}
/* .reports-content .table tbody .additional-row {
  background-color: #f0f2d0;
} */
.reports-content .table tbody .tr-invalid {
  background-color: #fff8f8;
}
.reports-content .table tbody tr:not(.tr-planned):hover {
  background-color: #e8e8f3;
}
/* .reports-content .table tbody .additional-row:hover {
  background-color: rgb(230, 233, 194);
} */
.reports-content .table tbody .additional-td {
  position: relative;
  padding-left: 35px;
}
.additional-td::before {
  color: #d88e0f;
  font-size: 16px;
  /* font-weight: 700; */
  font-family: "mck";
  left: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.additional-td-mechanization::before {
  /* font-family: "mck2"; */
  content: "n";
}
.additional-td-rentedMechanization::before {
  /* font-family: "mck"; */
  content: "m";
}
.additional-td-material::before {
  content: "G";
}
.additional-td-activity::before {
  content: "O";
}
.reports-content .table tbody .sum-row {
  background-color: transparent;
  font-size: 14px;
  font-weight: 700;
}
.reports-content .table tbody .sum-row td:first-child {
  padding-right: 30px;
  text-align: right;
}
.inquiry-title-wrapper {
  padding: 10px 10px 0px;
}
.inquiry-title {
  color: var(--color-main);
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  width: 100%;
}
.inquiry-title-invalid {
  color: #bf392a;
}
.no-reports {
  /* background-color: #fff; */
  /* border-radius: 4px; */
  padding: 20px;
  text-align: center;
  width: 100%;
}
.td-center {
  text-align: center;
}
.table-wrapper {
  overflow: auto;
}
.date-toggles {
  align-items: center;
  display: flex;
}
.date-toggle {
  align-items: center;
  background-color: #ccd1e3;
  border: 1px solid #ccd1e3;
  border-radius: 4px;
  color: #8d3506;
  cursor: pointer;
  font-size: 20px;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  margin-left: 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 30px;
}
.date-toggle:hover {
  border-color: rgba(141, 53, 6, 0.2);
}
.date-toggle-active,
.date-toggle-active:hover {
  background-color: #ffe0b2;
  border-color: #8d3506;
}
.underline-hover {
  color: var(--color-main);
  font-weight: 700;
}
.underline-hover:hover {
  text-decoration: underline;
}
.tr-padding {
  padding: 10px 0;
}
.padding-for-tag {
  padding-right: 75px;
}
.td--third {
  width: 33%;
}
.space-between {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.space-between > span {
  padding-bottom: 1px;
  padding-top: 1px;
}
.regular {
  font-weight: 400;
}
.border-right {
  border-right: 1px solid rgba(112, 112, 112, 0.5);
  padding-right: 20px;
}
/* .desktop { */
/* display: flex; */
/* } */
.mobile {
  display: none;
}
/* Responsive */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: inline-grid;
  }
  .inquiry {
    padding: 10px 15px;
  }
  .inquiry-header {
    height: initial;
  }
  .inquiry-header-controlls {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    width: 100%;
  }
  .inquiry-pre-datepicker-text {
    font-size: 20px;
  }
  .inquiry-filters-inputs {
    display: flex;
    flex-direction: column;
  }
  .inquiry-datepicker {
    margin-top: 10px;
    padding: 2px 0;
    width: 100%;
  }
  .new-input-wrapper {
    width: 100%;
  }
  .table-wrapper {
    overflow: auto;
  }
  .new-content-data-item-toggle-circle {
    height: 50px;
    width: 50px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.excel {
    background-color: green;
    bottom: 75px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.top {
    background-color: #6d2600;
    margin-top: 50px;
    position: inherit;
  }
  .new-content-data-item-toggle-circle .mck {
    border: 0px;
    font-size: 20px;
  }
  .modal-footer {
    background-color: #f0f0f7;
    height: 125px;
    padding: 0px;
  }
  .no-wrap {
    white-space: nowrap;
  }

  @media screen and (max-width: 600px) {
    .reports-tab {
      flex-direction: column;
    }
    .reports-tab span:first-child {
      margin: 0;
    }
    .inquiry-filters-btns {
      flex-direction: column;
    }
    .inquiry-filters-btns .btn {
      margin-top: 15px;
    }
  }
  @media screen and (max-width: 380px) {
    .reports-tab {
      font-size: 12px;
    }
    .checkboxes-wrapper {
      flex-direction: column;
    }
  }
}
</style>
